import React, { memo, useMemo } from "react"

import { useCheckout } from "../../../hooks/useCheckout"
import { useCartSettings } from "../../../hooks/useCartSettings"

export const withCartList = Component =>
  memo(({ name = "CartList" }: any) => {
    const { checkout, count } = useCheckout()
    const { emptyText, cartButtons } = useCartSettings()
    Component.displayName = name
    return useMemo(() => <Component checkout={checkout} count={count} emptyText={emptyText} cartButtons={cartButtons} />, [checkout, count])
  })
